import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import UserHoverDetails from "../../components/User/UserHoverDetails";
import CustomerShowDetails from "../../components/customer/CustomerShowDetails";
import AddUserModal from "../../components/User/AddUserModal";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";

import { ReactComponent as EmailIcon } from "../../assets/images/emailCustomerCard.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/PhoneIconCustomerCard.svg";
import AvatarName from "./AvatarName";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { useDispatch } from "react-redux";
import { GET_USER_DETAILS_MORE_DETAILS } from "../../utils/constants";
import { getCommonDataBasedOnId } from "../store/customer/CustomerSocialAddUpdateFunction";
import useRequireAuth from "../../utils/useRequireAuth";

const UserProfliePodModelDetails = ({
  userData,
  headerkey,
  title = "Edit User",
  isPermissionOpen,
  setIsPermissionOpen,
  refetchprofilePodTable,
}) => {
  const [openShowDetails, setOpenShowDetails] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [detaillOpen, setDetaillOpen] = useState(false);
  const dispatch = useDispatch();
  const { token } = useRequireAuth();

  const handleMoreClick = (e) => {
    e.stopPropagation();
    setOpenShowDetails(true);
  };

  const handleWrapClick = () => {
    setDetaillOpen(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  console.log("headerKey", userData);

  const CloseShowDetial = () => {
    setOpenShowDetails(false);
    setDetaillOpen(false);
  };

  const data = [userData, headerkey];

  const initials = (headerkey == "user_name" ? userData?.user_name : userData?.reporting || "-")
    .split(" ")
    .filter((word) => word.length > 0)
    .map((word) => word.charAt(0).toUpperCase())
    .slice(0, 2)
    .join("");

  return (
    <>
      <div className="w-full h-full flex items-center justify-start cursor-pointer">
        <ToolTipComponent
          text={
            <>
              <div className="min-w-[249px]">
                <div className="rounded-lg bg-white">
                  <div className="space-y-2 gap-y-2">
                    <div className="flex gap-2 border-b-2 py-2 px-2">
                      <div>
                        <AvatarName
                          name={initials}
                          size="small"
                          bgColor={"#E8ECF299"}
                          textColor={"#7C7C83"}
                          borderColor={"#ABABAC"}
                        />
                      </div>
                      <div className="text-2999BC text-14">
                        {headerkey == "user_name" ? userData?.user_name : userData?.reporting || "-"}
                      </div>
                    </div>
                    <div className="flex items-start justify-centre flex-col gap-y-2 py-1">
                      <div className="flex px-2 gap-2">
                        <div className="w-5 text-center">
                          <EmailIcon />
                        </div>
                        <div className="text-F16136 text-12">
                          {headerkey === "user_name" ? userData?.user_email : userData?.reporting_email || "-"}
                        </div>
                      </div>

                      <div className="flex px-2 gap-2 ">
                        <div className="w-5 text-center">
                          <PhoneIcon />
                        </div>
                        <div className="text-F16136 text-12">
                          {headerkey === "user_name"
                            ? userData?.mobile == null
                              ? "-"
                              : userData?.mobile
                            : userData?.reporting_mobile || "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end text-12 my-2 border-t-2 border-[#E8ECF2] ">
                    <button className="text-blue-500 mt-2" onClick={(e) => handleMoreClick(e)}>
                      Show more
                    </button>
                  </div>
                </div>
                <div></div>
              </div>
            </>
          }
          PopperProps={{ style: { zIndex: 99999 } }}
          placement="top"
          arrow
        >
          <div onClick={handleWrapClick} className="w-full cursor-pointer font-600 text-[#2999BC]">
            {headerkey === "user_name" ? userData?.user_name : userData?.reporting}
          </div>
        </ToolTipComponent>

        {(openShowDetails || detaillOpen) && (
          <CustomerShowDetails
            open={openShowDetails || detaillOpen}
            onClose={CloseShowDetial}
            Data={data}
            setOpenModal={setOpenModal}
            setOpenShowDetails={setOpenShowDetails}
            setDetaillOpen={setDetaillOpen}
            enableEditButton={true}
          />
        )}

        {openModal && (
          <AddUserModal
            open={openModal}
            closePopup={closeModal}
            title={title}
            handelsave={refetchprofilePodTable}
            editData={headerkey === "user_name" ? userData?.userUuid : userData?.reporting_uuid || ""}
            isPermissionOpen={isPermissionOpen}
            setIsPermissionOpen={setIsPermissionOpen}
          />
        )}
      </div>

      {/* how to wrap the component */}
      {/* <UserProfliePodModelDetails userData={info.row.original}>
        
        <span className="font-normal text-blue-600">{info.row.original?.user_name}</span>
      </UserProfliePodModelDetails> */}
    </>
  );
};

export default UserProfliePodModelDetails;
